import { useQuery, useQueryClient } from "@tanstack/react-query";
import { SystemLicenses } from "@graylog/enterprise-api";
import { qualifyUrl } from "util/URLUtils";
import UserNotification from "util/UserNotification";
import fetch from "logic/rest/FetchProvider";
export const LICENSE_TRAFFIC_VIOLATION_QUERY_KEY = ["license", "traffic-violation"];
const fetchTrafficViolation = () => SystemLicenses.getTrafficLimitViolations().then((response) => {
  var _a, _b;
  return {
    acknowledged: (_a = response.state) == null ? void 0 : _a.acknowledged,
    mostRecentViolation: (_b = response.state) == null ? void 0 : _b.most_recent_violation
  };
}).catch((error) => {
  UserNotification.error(
    `Fetching Traffic limit violation failed with status: ${error}`,
    "Could not retrieve Traffic limit violation"
  );
  return { acknowledged: void 0, mostRecentViolation: void 0 };
});
export const acknowledgeTrafficViolation = () => {
  const url = qualifyUrl("/plugins/org.graylog.plugins.license/licenses/traffic-limit-violations/acknowledgement");
  return fetch("PUT", url, {}).catch((error) => {
    UserNotification.error(
      `Saving Traffic limit violation acknowlegment failed with status: ${error}`,
      "Could not save Traffic limit violation acknowledgment"
    );
    throw error;
  });
};
const useLicenseTrafficViolation = () => {
  const queryClient = useQueryClient();
  const { data } = useQuery({
    queryKey: LICENSE_TRAFFIC_VIOLATION_QUERY_KEY,
    queryFn: fetchTrafficViolation,
    retry: false
  });
  const invalidate = () => queryClient.invalidateQueries({ queryKey: LICENSE_TRAFFIC_VIOLATION_QUERY_KEY });
  return {
    acknowledged: data == null ? void 0 : data.acknowledged,
    mostRecentViolation: data == null ? void 0 : data.mostRecentViolation,
    invalidateTrafficViolation: invalidate
  };
};
export default useLicenseTrafficViolation;
